// extracted by mini-css-extract-plugin
export default {"cardFooter":"wCf9G","right":"VwDLO","left":"jByii"};